import { render, staticRenderFns } from "./page_add_full.vue?vue&type=template&id=2dc72ca2&scoped=true"
import script from "./page_add_full.vue?vue&type=script&lang=js"
export * from "./page_add_full.vue?vue&type=script&lang=js"
import style0 from "./page_add_full.vue?vue&type=style&index=0&id=2dc72ca2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc72ca2",
  null
  
)

export default component.exports